import request from '@/utils/request'

export function getNewsList(params) {
  return request({
    url: '/prod-api/cms/news/list',
    method: 'get',
    params
  })
}

export function getNewsDetail(id) {
  return request({
    url: `/prod-api/cms/news/${id}`,
    method: 'get'
  })
}